import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./ForgotPassword.css";

const ForgotPassword = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Email Validation
  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    // ✅ Validation
    if (!email.trim()) {
      return setError("Email is required.");
    }

    if (!validateEmail(email)) {
      return setError("Please enter a valid email address.");
    }

    try {
      setLoading(true);

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/auth/forgot-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Failed to send OTP.");
      }

      // ✅ Success
      setMessage(data.message || "OTP sent successfully!");

      // ✅ Redirect after 2 seconds
      setTimeout(() => {
        navigate("/reset-password", { state: { email } });
      }, 2000);

    } catch (err) {
      setError(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-main-container">
      <div className="forgot-container">

        {/* LEFT PANEL */}
        <div className="forgot-left-panel">
          <h1>Password Recovery</h1>
          <p>Secure your account with OTP verification</p>
        </div>

        {/* RIGHT PANEL */}
        <div className="forgot-right-panel">
          <h3>Hello!</h3>
          <h2>Forgot Password?</h2>

          <p className="forgot-text">
            Enter your <span>Email</span> to receive OTP
          </p>

          <form onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <button type="submit" disabled={loading}>
              {loading ? "Sending..." : "Send Reset OTP"}
            </button>
          </form>

          {message && (
            <div className="message-success">✅ {message}</div>
          )}

          {error && (
            <div className="message-error">❌ {error}</div>
          )}

          <div className="back-to-login">
            <Link to="/login" className="forgot-link">
              Back to Login
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ForgotPassword;